import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  keyboardRow: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  keyboardCenter: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  row: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  keyStyle: {
    borderRadius: 1,
    borderColor: theme.colors.black,
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.white,
    shadowColor: theme.colors.black,
    shadowOffset: { width: 1, height: 1 },
    shadowOpacity: 0.3,
    shadowRadius: 1.8,
    elevation: 9,
  },
  wrongBg: {
    backgroundColor: theme.colors.red,
  },
  correctBg: {
    backgroundColor: theme.colors.primary,
  },
  lightColor: {
    color: theme.colors.lightGrey,
  },
  fontAbz: {
    fontFamily: 'ABeeZeeRegular',
  },
});
